module.exports = __webpack_public_path__ + "img/kh2_08.74451bcd.png";